import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input } from "antd";
import jwt_decode from "jwt-decode";
import { SyncOutlined } from "@ant-design/icons";
import { getRequest, postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { RWebShare } from "react-web-share";
import { ReactComponent as ShareV2Icon } from "../../assets/images/icons/shareV2.svg";
import "./LoginFormV2.scss";

const ERROR_MESSAGES = {
  INVALID_CREDS: "invalid email or password",
  WRONG_ROLE: "please login with organisation admin credentials",
  GENERIC: "something went wrong. please try again",
};

export default function LoginFormV2({ partnerData }) {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [form] = Form.useForm();

  const fetchOrgDetails = async (accessToken) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const response = await getRequest(userServiceApi.adminOrganization(), {
      headers,
    });

    if (response?.data) {
      const { id, mediaLink, name, isOrganizationProfilePending } =
        response.data;

      localStorage.setItem("OrgId", id);
      localStorage.setItem("OrgImage", mediaLink);
      localStorage.setItem("OrgName", name);

      return isOrganizationProfilePending ? "/edit-organization" : "/";
    }
  };

  const handleLogin = async (values) => {
    setLoading(true);
    setErrorMessage("");
    const trimmedPayload = {
      email: values?.email?.trim(),
      password: values?.password?.trim()
    }
    try {
      const response = await postRequest(userServiceApi.login(), trimmedPayload);

      if (!response) {
        setErrorMessage(ERROR_MESSAGES.INVALID_CREDS);
        return;
      }

      const { accessToken, refreshToken } = response;
      const decoded = jwt_decode(accessToken);

      if (decoded.role !== "ORGANIZATION_ADMIN") {
        setErrorMessage(ERROR_MESSAGES.WRONG_ROLE);
        return;
      }

      localStorage.setItem("token", accessToken);
      localStorage.setItem("refresh", refreshToken);
      localStorage.setItem("loginPage", "false");
      localStorage.setItem("OrgEmail", decoded.email);

      const redirectPath = await fetchOrgDetails(accessToken);
      navigate(redirectPath, {
        ...(redirectPath === "/edit-organization" && {
          state: { tab: "organizationDetailsTab" },
        }),
      });
    } catch (error) {
      setErrorMessage(error?.message || ERROR_MESSAGES.GENERIC);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="login-form-v2-action-icons">
        <RWebShare
          data={{
            url: window.location.href,
          }}
        >
          <ShareV2Icon title="Share" className="login-form-v2-share-icon" />
        </RWebShare>
      </div>

      <div className="login-form-v2-container">
        <div className="login-form-v2-card">
          {partnerData?.mediaLink && (
            <div className="login-form-v2-logo">
              <img src={partnerData.mediaLink} alt="partner logo" />
            </div>
          )}

          <Form
            form={form}
            layout="vertical"
            onFinish={handleLogin}
            className="login-form-v2-form"
            requiredMark={false}
          >
            <Form.Item
              label="Username"
              name="email"
              rules={[
                { required: true, message: "email is required" },
                { type: "email", message: "please enter a valid email" },
              ]}
              normalize={(value) => value?.trim()}
            >
              <Input
                placeholder="Enter username"
                size="large"
                className="login-form-v2-input"
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "password is required" }]}
            >
              <Input.Password
                placeholder="Enter password"
                size="large"
                className="login-form-v2-input"
              />
            </Form.Item>

            <div className="login-form-v2-forgot">
              <a href="/forgot-password" className="login-form-v2-forgot-link">
                Forgot Password
              </a>
            </div>

            {errorMessage && (
              <div className="login-form-v2-error">{errorMessage}</div>
            )}

            <button
              type="submit"
              className="login-form-v2-submit"
              disabled={loading}
            >
              {loading ? <SyncOutlined spin /> : "Login"}
            </button>
          </Form>

          <div className="login-form-v2-divider">
            <span>OR</span>
          </div>

          <a href="/signup" className="login-form-v2-signup-link">
            No Login / Apply Now
          </a>

          <div className="login-form-v2-footer">
            <img
              src={require("../../assets/images/PoweredNew.png")}
              alt="ConnectSU"
              onClick={() =>
                window.open("https://www.connectsu.co.uk/", "_blank")
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
